import styled from 'styled-components'
export const Wrapper = styled.div`
  .p-listbox .p-listbox-list .p-listbox-item:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: inset 0 0 0 0.15rem var(--second-color-1);
  }
  .p-listbox .p-listbox-list .p-listbox-item.p-highlight {
    color: var(--primary5);
    background: var(--second-color-1);
  }
`
